import { formatISO } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

export const getDateTime = (date?: string | null): string => {
  const current = date ? new Date(date) : new Date()
  return formatISO(current.setHours(0, 0, 0))
}

export const toISOWithOffset = (date: string) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone

  return formatInTimeZone(date, timeZone, "yyyy-MM-dd'T'HH:mm:ssXXX")
}
